var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M90.856 41.84H87.5v-.173H50v16.666h23.548C70.112 68.035 60.881 75 50 75c-13.806 0-25-11.194-25-25s11.194-25 25-25c6.373 0 12.17 2.404 16.585 6.331l11.786-11.785C70.929 12.61 60.975 8.333 50 8.333 26.99 8.333 8.333 26.99 8.333 50S26.99 91.667 50 91.667 91.667 73.01 91.667 50c0-2.794-.288-5.52-.81-8.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D00",
    d: "m13.137 30.606 13.69 10.04C30.531 31.475 39.502 25 50 25c6.373 0 12.17 2.404 16.585 6.331l11.786-11.785C70.929 12.61 60.975 8.333 50 8.333c-16.004 0-29.883 9.036-36.862 22.273Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M50 91.667c10.763 0 20.542-4.12 27.935-10.817L65.04 69.938A24.813 24.813 0 0 1 50 75c-10.837 0-20.04-6.91-23.506-16.554L12.906 68.915C19.802 82.408 33.806 91.667 50 91.667Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M90.856 41.84H87.5v-.173H50v16.666h23.548a25.083 25.083 0 0 1-8.515 11.607l.007-.005 12.895 10.913c-.912.83 13.732-10.015 13.732-30.848 0-2.794-.288-5.52-.81-8.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.34c9b26fa82c2ece443785d37b4aceef.svg";
export { ForwardRef as ReactComponent };